<template>
  <div>
    <div id="bg"></div>
    <div id="wrap">
      <ul class="blind">
        <li>
          <a href="#contents">본문 바로가기(Skip Contents)</a>
        </li>
      </ul>

      <!-- //header -->
      <SubHeaderWithSidebar title="타임테이블" />
      <!-- //header -->
      <Gnb v-if="showGnb" />

      <div id="container" ref="container">
        <section id="contents">
          <div class="main ttableWrap">
            <div class="mainClass">
              <h5 class="todayClass">Today Class</h5>
              <h3 class="classTitle">{{title}}</h3>
              <div class="img">
                <img :src="logo_src" alt />
              </div>
            </div>

            <div class="ttable">
              <div class="date">
                <!-- 
                            select box 디자인
                            클릭시 open class 추가
                            <div class="select"> ->  <div class="select open">
                -->
                <div class="select" style="display:none;">
                  <h3>
                    <img src="@/assets/img/select_arrow.png" alt="더보기" />
                  </h3>
                  <ul class="optionWrap">
                    <li class="option">
                      <a href>2020년 2월 26일</a>
                    </li>
                    <li class="option">
                      <a href>2020년 3월 5일</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tbody">
                <table cellpadding="0" cellspacing="0">
                  <colgroup>
                    <col width="30%" />
                    <col width="70%" />
                  </colgroup>
                  <tr>
                    <th>시간</th>
                    <th>내용</th>
                  </tr>
                  <Row v-bind:key="item.id" :item="item" v-for="item in items" />
                </table>
              </div>
            </div>
            <!-- ttable -->
          </div>
        </section>
        <!-- //contents -->
      </div>
      <!-- //container -->
    </div>
    <!-- //wrap -->
  </div>
</template>


<script>
import SubHeaderWithSidebar from "@/components/SubHeaderWithSidebar";
import Gnb from "@/components/Gnb";
import Row from "@/components/timetable/Row";
import { Constant } from "@/utils/const";
import * as R from "ramda";
import sideMixin from "@/components/SideMixin";
export default {
  mixins: [sideMixin],
  created() {
    let clsid = localStorage.getItem("clsid");
    this.$store.dispatch("setClassInfo", clsid);
    let url = `${Constant.FullGetApi}?classroom_id=${clsid}`;
    this.$axios.get(url).then(resp => {
      let data = resp.data.rows;
      let timetable = R.filter(i => i.flag === "timetable", data);
      let exclude = R.filter(i => i.flag !== "timetable", data);

      let i = 0;
      timetable = R.map(t => {
        let _next = 0;
        if (i + 1 < timetable.length) {
          _next = timetable[i + 1].index;
        } else {
          _next = 10000;
        }

        let _curr = t.index;
        let fectures = R.filter(
          x => x.index > _curr && x.index < _next,
          exclude
        ).reduce((x, y) => {
          x.push({
            flag: y.flag,
            index: y.index,
            paper_id: y.id,
            subflag: y.subflag
          });
          return x;
        }, []);
        t.fectures = fectures;
        i++;
        return t;
      }, timetable);

      console.log(timetable);

      this.items = timetable;
    });
  },
  data() {
    return {
      items: []
    };
  },
  components: { SubHeaderWithSidebar, Gnb, Row },
  computed: {
    showGnb: function() {
      return this.$store.getters.getShowGnb;
    },
    title() {
      return this.$store.state.clsMeta.title;
    },

    attInfo() {
      return this.$store.getters.getClsMeta;
    },

    logo_src() {
      /// @/assets/img/mega_logo.png
      let logo_src = this.attInfo.logo;
      if (logo_src != null) {
        return JSON.parse(logo_src).url;
      } else {
        return require("@/assets/img/mega_logo.png");
      }
    }
  }
};
</script>


<style lang="scss" scoped>
#wrap {
}

#container {
  min-height: 100vh;
}

.main {
  text-align: center;
  padding-top: 55px;
  padding-bottom: 20px;
  min-height: 100vh;
  position: relative;
  background: #d7d7d7;
}

.mainSlider {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}

.mainSlider ul {
  text-align: left;
  position: relative;
  font-size: 0;
}

.mainSlider ul li {
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: relative;
}

.mainSlider ul li .logo {
  margin-bottom: 15px;
}

.mainSlider ul li .logo img {
  width: 125px;
}

.mainSlider ul li h3 {
  font-size: 16px;
  color: #ffffff;
}

.mainSlider ul li .icon {
  margin: 26px auto 10px;
}

.mainSlider ul li .icon img {
  width: 107px;
  margin-left: -10px;
}

.mainSlider ul li p {
  font-size: 14px;
  color: #ffffff;
}

.mainSlider ul li .img {
  overflow: hidden;
}

.mainSlider ul li .img img {
  width: 100%;
}

.mainSlider ul li .text {
  position: absolute;
  left: 50%;
  top: 38%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.mainSlider ul li .text {
}

.mainSlider .paging {
  margin-top: 20px;
  position: absolute;
  bottom: 55px;
  left: 0;
  width: 100%;
}

.mainSlider .paging ul {
  text-align: center;
}

.mainSlider .paging ul li {
  display: inline-block;
  vertical-align: top;
  margin: 0 3px;
  padding-top: 30px;
}

.mainSlider .paging ul li a {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: block;
}

.mainSlider .paging ul li.active {
}

.mainSlider .paging ul li.active a {
  background: rgba(255, 255, 255, 1);
}

.mainClass {
  position: relative;
  z-index: 2;
  border-radius: 10px;
  background: #ffffff;
  width: 90%;
  margin: -40px auto 0;
  padding-bottom: 30px;
  box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, 0.3);
}

.mainClass h5.todayClass {
  width: 125px;
  margin: 0 auto;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  background: #49c5c5;
  border-radius: 0 0 10px 10px;
}

.mainClass h3.classTitle {
  color: #2c3a38;
  font-size: 23px;
  text-align: center;
  padding: 0 10%;
  font-weight: 600;
  line-height: 1.2em;
  margin-top: 20px;
}

.mainClass .img {
  width: 90%;
  margin: 10px auto 0;
  height: 50px;
  line-height: 50px;
  border: 1px solid #f4f1f1;
  border-radius: 10px;
}

.mainClass .img img {
  width: 33%;
}

.mainClass .icon {
  width: 95px;
  height: 95px;
  border-radius: 100%;
  line-height: 95px;
  background: #f9f9f9;
  text-align: center;
  margin: 25px auto;
}

.mainClass .icon img {
  width: 50px;
}

.mainClass p {
  color: #c0c0c0;
  font-size: 14px;
  text-align: center;
}

.logoutBtn {
  background: #fff;
  text-align: center;
  width: 111px;
  border-radius: 8px;
  box-shadow: 1px 1px 6px 2px rgba(0, 0, 0, 0.2);
  position: absolute;
  left: 20px;
  top: 85%;
}

.logoutBtn a {
  color: #666666;
  font-size: 16px;
  display: block;
  height: 40px;
  line-height: 40px;
}

.logoutBtn a img {
  width: 17.5px;
  margin: -2px 0 0 3px;
}

.logoutPop {
  position: fixed;
  left: 50%;
  top: 80px;
  z-index: 100;
  background: #ffffff;
  transform: translateX(-50%);
  width: 90%;
  border-radius: 10px;
  padding: 20px;
}

.logoutPop p {
  color: #666666;
  font-size: 14px;
  line-height: 1.6em;
  text-align: center;
}

.logoutPop p span {
  color: #000000;
}

.logoutPop .btn {
  text-align: center;
  margin-top: 10px;
}

.logoutPop .btn a {
  width: 85px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  color: #ffffff;
  background: #9f9f9f;
  border-radius: 5px;
  display: inline-block;
  vertical-align: top;
  font-size: 13px;
}

.logoutPop .btn a.check {
  background: #309f93;
}

.gnb {
  position: relative;
  position: absolute;
  right: -100%;
  top: 0;
  height: 100vh;
  background: #ffffff;
  z-index: 102;
  width: 70%;
}

.gnb h3 {
  text-align: center;
  color: #000;
  font-size: 17px;
  line-height: 1.3em;
  padding: 10% 0;
}

.gnb ul {
  font-size: 0;
  border-top: 1px solid #e3e3e3;
}

.gnb ul li {
  display: inline-block;
  vertical-align: top;
  width: 50%;
  border-bottom: 1px solid #e3e3e3;
}

.gnb ul li:nth-child(2n + 1) {
  border-right: 1px solid #e3e3e3;
}

.gnb ul li .icon {
  height: 80px;
  line-height: 80px;
}

.gnb ul li .icon img {
}

.gnb ul li:nth-child(1) .icon img {
  width: 43px;
}

.gnb ul li:nth-child(2) .icon img {
  width: 43px;
}

.gnb ul li:nth-child(3) .icon img {
  width: 50px;
}

.gnb ul li:nth-child(4) .icon img {
  width: 41px;
}

.gnb ul li:nth-child(5) .icon img {
  width: 55px;
}

.gnb ul li:nth-child(6) .icon img {
  width: 55px;
}

.gnb ul li a {
  height: 115px;
  width: 100%;
  display: block;
  text-align: center;
  color: #666666;
  font-size: 15px;
}

.main.ttableWrap {
  background: #2f2f30;
}

.main.ttableWrap .mainClass {
  margin: 30px auto 0;
}

.main.ttableWrap .mainClass h3.classTitle {
  font-size: 18px;
}

.ttable {
  position: relative;
  z-index: 2;
  border-radius: 10px;
  background: #ffffff;
  width: 90%;
  margin: 10px auto;
  padding-bottom: 30px;
  box-shadow: 5px 5px 10px 2px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.ttable .date {
  background: #f7f7f7;
  padding: 15px 0;
}

.ttable .date .select {
  position: relative;
  width: 80%;
  margin: 0 auto;
}

.ttable .date .select h3 {
  position: relative;
  height: 35px;
  line-height: 35px;
  border: 1px solid #e5e5e5;
  padding: 0 30px 0 15px;
  border-radius: 10px;
  color: #666666;
  font-size: 14px;
  text-align: left;
  margin: 0 auto;
  background: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ttable .date .select h3 img {
  position: absolute;
  right: 15px;
  top: 50%;
  margin-top: -3.5px;
  width: 13px;
}

.ttable .date .select.open h3 img {
  transform: rotate(180deg);
}

.ttable .date .select ul {
  border: 1px solid #e5e5e5;
  position: absolute;
  width: 100%;
  left: 0;
  top: 34px;
  border-radius: 10px;
  height: 200px;
  overflow-y: auto;
  display: none;
}

.ttable .date .select.open ul {
  display: block;
}

.ttable .date .select ul li {
  border-top: 1px solid #e5e5e5;
  background: #ffffff;
  padding: 0 15px;
  text-align: left;
  font-size: 14px;
  color: #666666;
}

.ttable .date .select ul li:first-child {
  border-top: none;
}

.ttable .date .select ul li a {
  display: block;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ttable .tbody table {
  width: 100%;
}

.ttable .tbody table th,
.ttable .tbody table td {
}

.ttable .tbody table th {
  text-align: center;
  color: #666666;
  font-size: 14px;
  padding: 15px 0;
  border-bottom: 1px solid #2f2f30;
  font-weight: 700;
}

.ttable .tbody table td {
  text-align: left;
  padding: 10px 0;
  border-bottom: 1px solid #f3f3f3;
}

.ttable .tbody table tr td:first-child {
  text-align: center;
  color: #666666;
  font-size: 14px;
}

.ttable .tbody table td p {
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
}

.ttable .tbody table td span.card {
  width: 47px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #ffffff;
  font-size: 12px;
  background: #3a5cd9;
  display: inline-block;
  vertical-align: top;
  border-radius: 4px;
}

.ttable .tbody table td span.quiz {
  background: #30c0bd;
}

.ttable .tbody table td span.qna {
  background: #dc688f;
}

.ttable .tbody table td span.poll {
  background: #efc774;
}

.ttable .tbody table td span.share {
  background: #e0dd37;
}
</style>